import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { A11yModule } from '@angular/cdk/a11y';

import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Observable } from "rxjs/internal/Observable";
import { Subject, catchError, debounceTime, distinctUntilChanged, of, switchMap } from "rxjs";
import { trigger, state, style, transition, animate } from "@angular/animations"
import { ExtendedOrderType } from "../../core/enums";
import { NgbPopover, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { SearchResult } from "../../core/models";
import { SearchService } from "../../core/services/search.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CategoryPopoverComponent } from "./category-popover/category-popover.component";
import { MerchantPopoverComponent } from "./merchant-popover/merchant-popover.component";
import { ProductPopoverComponent } from "./product-popover/product-popover.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgClickOutsideExcludeDirective } from "ng-click-outside2";

@Component({
    selector: 'app-search-bar',
	    standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		A11yModule,
		NgbPopoverModule,
		NgClickOutsideExcludeDirective,
		TranslocoPipe,
		CategoryPopoverComponent,
		MerchantPopoverComponent,
		ProductPopoverComponent
	],
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.css'],
    animations: [
        trigger('overlay', [
            state('true', style({ opacity: 0.3, pointerEvents: 'all' })),
            state('false', style({ opacity: 0, pointerEvents: 'none' })),
            transition('true <=> false', [animate('0.15s ease-in')])
        ])
    ],
    encapsulation: ViewEncapsulation.None,
})
export class SearchBarComponent implements OnInit {

	ExtendedOrderType = ExtendedOrderType

	readonly MIN_QUERY_LENGTH = 1;
	readonly MAX_RESULT_COUNT = 9;
	readonly TOP_OFFSET = 120; // top gap + navbar + results container heading
	readonly RESULT_HEIGHT = 70;

	query: string;
	private searchTerms = new Subject<string>();
	results$: Observable<SearchResult[]> = of([]);

	mobileThreshold = 852;
	isFocused: boolean = false;
	popoverInstances: any = {}; //I realize this isn't the best way, but it'll do for now

	constructor(
		public translate: TranslocoService, 
		private searchService: SearchService,
	) {
		this.results$ = this.searchTerms.pipe(
			takeUntilDestroyed(),
			debounceTime(300),
			distinctUntilChanged(),
			switchMap(query => this.searchService.searchMarket(query)),
			catchError((_err, o) => o)
			// switchMap(query => iif(() => query.length < this.MIN_QUERY_LENGTH, this.searchService.searchMarket(query), this.trendingResults$))
		);
	}

	ngOnInit(): void {
		setTimeout(() => this.searchTerms.next(""), 100);
		//TODO: Potentially load to on click
	}

	get resultCountLimit() {
		return Math.min((this.windowHeight - this.TOP_OFFSET - this.RESULT_HEIGHT) / this.RESULT_HEIGHT, this.MAX_RESULT_COUNT);
	}

	get windowHeight() {
		return typeof window !== 'undefined' ? window.innerHeight : 0;
	}

	get isMobile() {
		return (typeof window !== "undefined") && (window.innerWidth < this.mobileThreshold);
	}

	onClick(isClickInside: boolean) {
		this.isFocused = isClickInside;
	}

	toggleSearchBar() {
		this.isFocused = !this.isFocused;
	}

	onInput() {
		this.searchTerms.next(this.query);
	}

	onMouseEnter(p: NgbPopover, isPopover: boolean, key: string) {
		let state = this.popoverInstances[key];
		if (!state) state = this.popoverInstances[key] = {
			isInPopover: false,
			isInListItem: false
		} //TODO: can probs combine with previous statement
		isPopover ? state.isInPopover = true : state.isInListItem = true;
		setTimeout(() => (state.isInPopover != state.isInListItem) ? p.open() : null, 350);
	}

	onMouseLeave(p: NgbPopover, isPopover: boolean, key: string) {
		let state = this.popoverInstances[key];
		isPopover ? state.isInPopover = false : state.isInListItem = false;
		setTimeout(() => (state.isInPopover == state.isInListItem) ? p.close() : null, 150);
	}

}

